import React, { FC, HTMLAttributes } from 'react';

import classNames from 'classnames';

import styles from './CustomLink.module.css';

interface Props extends HTMLAttributes<HTMLAnchorElement> {
  to: string;
  color: 'primary' | 'blank';
  underline?: boolean;
}

export const CustomLink: FC<Props> = ({
  children,
  to,
  color,
  underline,
  ...rest
}) => {
  return (
    <a
      className={classNames(
        styles.link,
        styles[color],
        underline && styles.underline,
      )}
      target="_blank"
      rel="noopener noreferrer"
      href={to}
      {...rest}
    >
      {children}
    </a>
  );
};
